module.exports = __webpack_public_path__ + "static/media/findus.778a4dc7.jpg";